/* eslint-disable */

import React, { Component } from 'react';
import styled from 'styled-components';
import { Button, Icon } from 'semantic-ui-react';

import instagramIcon from '../../assets/images/instagram-icon.png';
import facebookIcon from '../../assets/images/facebook-icon.png';

const Container = styled.div`
  width: 100%;
  height: auto !important;
`;
const AccountItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: ${(props) => (props.border ? '1px solid #ddd' : 'none')};
`;
const PlatformItem = styled.div`
  flex: 0.4;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const PageItem = styled.div`
  flex: 0.5;
`;
const ActionItem = styled.div``;
const Logo = styled.img`
  height: 18px;
  margin-right: 5px;
`;
const RemoveAction = styled.div`
  width: 86px;
`;
const TextItem = styled.span`
  color: #121212;
  font-size: 16px;
`;
const TextType = styled.span`
  color: #999;
  font-size: 12px;
  display: block;
  font-weight: 700;
`;

class LobItemComponent extends Component {
  render() {
    const { id, lobId, item, removeAccount } = this.props;
    const text = item.type === 'instagram' ? 'Instagram' : 'Facebook';
    let typeAccount = '';

    switch (item.type) {
      case 'instagram':
        typeAccount = 'Instagram Account';
        break;
      case 'facebook':
        typeAccount = 'Page Account';
        break;
      case 'facebookAd':
        typeAccount = 'Ad Account';
        break;
      default:
        typeAccount = '';
        break;
    }

    return (
      <AccountItem border>
        <PlatformItem>
          {item.type === 'instagram' ? (
            <Logo src={instagramIcon} className="ui" alt={text} />
          ) : (
            <Logo src={facebookIcon} className="ui" alt={text} />
          )}
          <TextItem>
            {text} <strong>Active</strong>
          </TextItem>
        </PlatformItem>
        <PageItem>
          <TextItem>
            <strong>{item.user.username}</strong>
            <TextType>{typeAccount}</TextType>
          </TextItem>
        </PageItem>
        <ActionItem>
          <RemoveAction>
            {/* <Button
              onClick={() => this.props.history.push('/share/instagram', { tab: 'instagram' })}
              color='blue'
              basic
              icon
            >
              <Icon name='eye' />
            </Button> */}
            <Button
              onClick={() => removeAccount(lobId, id)}
              color="red"
              loading={false}
              basic
              icon
            >
              <Icon name="trash" />
            </Button>
          </RemoveAction>
        </ActionItem>
      </AccountItem>
    );
  }
}

export default LobItemComponent;



// WEBPACK FOOTER //
// ./src/components/share/LobItem.js